import React, { useRef, useState } from 'react'
import { Dialog, toaster } from 'evergreen-ui';
import {useHistory } from 'react-router-dom';
import {
  PageTitleText 
} from '../../../../../widget/styledComponents/headings.style';
import {
  FieldBtn
} from '../security.style'
import {
  AppInputField,InputFieldTitleText,AppInputFieldBtn,AppInputFieldBtnCancel 
} from '../../../../../widget/styledComponents/input_field.style'
import Cookies from 'js-cookie';
import { gql, useMutation } from '@apollo/client';



export const ADD_RESIDENT = gql`
mutation Security_initializeAccount($name: String!, $email: String!, $phone: String!, $facilityId: ID!) {
  security_initializeAccount(name: $name, email: $email, phone: $phone, facilityId: $facilityId) {
    code
    success
    error
    data {
      _id
      name
      email
      facility
      isActive
    }
    token
  }
}
`;





const AddSecurityBtn = () => {
const history = useHistory()
const accesTokenValue = Cookies.get('userAccessToken');
const facilityId = Cookies.get('facilityId');
const [ addResident, { loading, }] = useMutation(ADD_RESIDENT);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

const handleSubmit = (e)=>{
  e.preventDefault()
  console.log()
  addResident({
    variables: { 
      email: emailRef.current.value,
      name: nameRef.current.value,
      facilityId:facilityId,
      phone: phoneRef.current.value,
    },
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Security added successfully.")
    history.push('/dashboard')
  })
  .catch((error) => {
    toaster.danger(error.message)
  });

}

const nameRef = useRef(null);
const emailRef = useRef(null);
const phoneRef = useRef(null);

  return (
    <div>

      <FieldBtn onClick={handleOpenDialog} class="waves-effect waves-light btn-flat  ">
          <i class="material-icons left">add</i>
          Add New Security
      </FieldBtn>
      <Dialog
        width="55%"
        isShown={isDialogOpen}
        title="Add New security"
        // onCloseComplete={() => setIsDialogOpen(false)}
        hasHeader={false}
        hasFooter={false}
        shouldCloseOnEscapePress={false}
        shouldCloseOnOverlayClick={false}
      >
        <form onSubmit={handleSubmit}>
        
        <div className='container'>
          <PageTitleText className='pl-16 pt-25'  style={{
                  color:"#4F46E5 !important",
                  padding:"16px !important"
              }}>
                 Add New Security
          </PageTitleText>
          <div className='row'>
              <div className='col s12 m12 l6'>
                  <InputFieldTitleText>
                       Name
                  </InputFieldTitleText>
                  <AppInputField
                      type="text" 
                      placholder="alijames@gmail.com"
                      ref={nameRef}
                  required/> 
              </div>
              <div className='col s12 m12 l6'>
                  <InputFieldTitleText>
                      Email
                  </InputFieldTitleText>
                  <AppInputField
                      type="email" 
                      placholder=""
                      ref={emailRef}
                  required/> 
              </div>
              <div className='col s12 m12 l6'>
                  <InputFieldTitleText>
                    Phone No
                  </InputFieldTitleText>
                  <AppInputField
                      type="tel" 
                      placholder=""
                      ref={phoneRef}
                  required/> 
              </div>
             

          </div>
      </div>
        <div className='row'>
            <div className='col s12 right' style={{
                display:"flex",
                flexWrap:"wrap",
                justifyContent:"end"
            }}>
                
                <div className='' style={{
                    width:"100px",
                    padding:"16px "
                }}>
                    <AppInputFieldBtnCancel 
                    className='btn btn-flat center p-2'
                    style={{
                        background:"transparent !important"
                    }} 
                    onClick={() => setIsDialogOpen(false)}
                  >
                        Cancel
                    </AppInputFieldBtnCancel >
                </div>
                <div className='' style={{
                    width:"120px",
                    padding:"16px "
                }}>
                    <AppInputFieldBtn type='submit' className='' disabled={loading}>
                        Add
                    </AppInputFieldBtn>
                </div>
            </div>
        </div>
      </form>

      </Dialog>
    </div>
  );
};

export default AddSecurityBtn;
